import React from 'react';
import Notes from "./Notes/Notes.jsx";
import AppointmentTabs from './AppointmentTabs/AppointmentTabs.jsx';
import Classes from './Details.module.css';

export default function Details({ booking, refresh }) {
  return (
    <div className={Classes.details}>
      <div className={Classes.detailsLeft}>
        <Notes booking={booking} refresh={refresh} />
      </div>
      <div className={Classes.detailsRight}>
        <AppointmentTabs booking={booking} refresh={refresh} />
      </div>
    </div>
  );
}
